angular.module('app.filters').filter('youtubeLiveSettings', () =>
    function(settings) {
        if (settings && settings.youtube_account_id && settings.privacy) {
            let url = null;
            if (settings.youtube_broadcast_id && (settings.privacy == 'public' || settings.privacy == 'unlisted')) {
                url = `https://www.youtube.com/watch?v=${settings.youtube_broadcast_id}`;
            }

            let status = 'Linked';
            if (settings.youtube_broadcast_id) {
                status = 'Published';
            }

            let privacy = null;
            if (settings.privacy == 'public') {
                privacy = 'publicly';
            } else if (settings.privacy == 'private') {
                privacy = 'privately';
            } else if (settings.privacy == 'unlisted') {
                privacy = 'and set unlisted'
            }

            let byWhom = null;
            if (settings.youtube_display_name) {
                byWhom = settings.youtube_display_name.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            }

            return `YouTube: ${url ? `<a href="${url}" target="_blank">` : ''}${status}${privacy ? ` ${privacy}` : ''}${byWhom ? ` by ${byWhom}` : ''}${url ? "</a>" : ''}`;
        } else {
            return 'YouTube: Not linked';
        }
    }
);


// WEBPACK FOOTER //
// ./filters/youtube_live_settings.js